import styled from 'styled-components'
import { Button } from 'antd'

export const LoginButton = styled(Button)<{ $isHome: boolean; $isScrolled: boolean }>`
  color: ${({ $isHome, $isScrolled }) => ($isHome && !$isScrolled ? 'white' : '#030852')};
  background: transparent;
  border: none;
  box-shadow: none;

  &:hover {
    color: #fdb123 !important;
    background: transparent !important;
  }
  @media screen and (max-width: 630px) {
    display: none;
  }
`
